import { useEffect, useState, useMemo, useCallback } from "react";
import PageHeaderPortal from "../components/PageHeaderPortal";
import { saveNewCost, deleteCost, changestatus, AddAditionalVFEdit } from "../api/aditionalCostsSystem";
import Tabs from "../components/Tabs";
import { BsCardChecklist, BsClock, BsPlus, BsShieldCheck, BsPatchQuestion, BsCloudUpload, BsCloud, BsLink } from 'react-icons/bs';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '../components/Dialog';
import Snackbar from '../components/Snackbar'; 
import StatCard from '../components/StatCard';
import Table from '../components/Table';
import Button from '../components/Button';
import Input from '../components/Input';
import Select from '../components/Select';
import CostActions from '../components/CostActions';
import { useAuth } from '../store/auth';
import { format, parseISO } from 'date-fns';
import { pl } from 'date-fns/locale';
import CostDetailsDialog from '../components/Dialogs/CostDetailsDialog';
import AddEditCostsDialog from '../components/Dialogs/AddEditCostsDialog';
import AddEditFVAditionalCostDialog from "../components/Dialogs/AddEditFVAditionalCostDialog";
export default function SystemCosts() {
  const [costs, setCosts] = useState([]);
  const [toast, setToast] = useState({ open: false, message: '', severity: 'success' });
  const [loading, setLoading] = useState(false); 
  const [options, setOptions] = useState({ userCanAdd: [], allFv: [], statuses: [], users: [] });
  const { user, logout } = useAuth();
  const [editing, setEditing] = useState(false);
  const emptyDetails = {
  id: null,
  title: '',
  fv_whoPay: null,
  amount: 0
};
  const [details, setDetails] = useState(emptyDetails);
  const [form, setForm] = useState({ costTitle: "", cost: "", costDate: "", costPaidBy: "" });
  const [formFV, setFormFV] = useState({ costTitle: "", cost: "", costDate: "", costPaidBy: "" });
  const [openAddCost, setOpenAddCost] = useState(false);
  const [openAddFV, setOpenAddFV] = useState(false);
  const [editingFV, setEditingFV] = useState(false);
     let logedUser = useAuth((state) => state.user);
  
     const submitFormFV = async (data) => {

      const newData = {
        ...formFV,
        idfakturyParent: details.id,
 
      }

      const result = await AddAditionalVFEdit(newData);
     // if (result.success === true) {
     setOpenAddFV(false);
        setToast({ open: true, message: result.message , severity: result.status });
   
    // };
    }
  const onDelete = useCallback(async (row) => {
   // await deleteLicense(id);
   const result = await deleteCost(row);
   if (result.success === true) {
     setOptions(prev => ({
       ...prev,
       allFv: prev.allFv.filter(fv => fv.id !== row.id)
     }));
     setToast({ open: true, message: 'Usunięto fakturę kosztową', severity: 'success' });
   } else {
     setToast({ open: true, message: result.message || 'Błąd podczas usuwania', severity: 'error' });
   }
  //  getAllData();
  }, []);

  const safeDate = (dateString) => dateString ? dateString : null;

  const [openDetailsCost, setOpenDetailsCost] = useState(false);
  
  const handleOpenDetailsCost = (row) => {
    setDetails(row);
    setOpenDetailsCost(true);
    
  };

  const submitForm = async () => {
    // przygotuj nowy koszt z bezpieczną datą
    const costToAdd = {
      id: form.id||0,
      status: form.status || "1",
      title: form.costTitle,
      amount: form.cost,
      date: safeDate(form.costDate),
      paid_by: form.costPaidBy || null,
      fvnumber: form.numberFV || null,
      us_name: options.users.find(user => user.id === form.costPaidBy)?.us_name || 'BRAK'  
    };
     setOptions(prev => ({
    ...prev,
    allFv:
      costToAdd.id === 0
        ? [...prev.allFv, { ...costToAdd, id: Date.now() }] // ADD
        : prev.allFv.map(item =>
            item.id === costToAdd.id ? costToAdd : item // EDIT
          ),
  }));


    const pp = await saveNewCost(costToAdd);

        setToast({ open: true, message: pp.message, severity: pp.status });

    setOpenAddCost(false);

    // opcjonalnie reset form
    setForm({ costTitle: "", cost: "", costDate: "", costPaidBy: "" });
  };
const onEdit = useCallback((row) => {
    setEditing(row);
    setForm({
      status: row.status,
      id: row.id,
      costTitle: row.title,
      numberFV: row.fvnumber,
      cost: row.amount,
      costDate: row.date,
      costPaidBy: row.paid_by
   
    });
    setOpenAddCost(true);
  }, []);
const onRunCost = useCallback(async (row) => {

   setOptions(prev => ({
    ...prev,
    allFv: prev.allFv.map(item =>
      item.id === row.id
        ? { ...item, status: "4" }
        : item
    )
  }));
  const result = await changestatus(row,"4");
  setToast({ open: true, message: result.message, severity: result.status });
}, []);
  

  const getAllData = async () => {
    setLoading(true);
    try {
      const [fv, statuses, users] = await Promise.all([
        fetch("https://hs2api.razamit.pl/costfv", { credentials: 'include' }).then(res => res.json()),
        fetch("https://hs2api.razamit.pl/costStatuses", { credentials: 'include' }).then(res => res.json()),
        fetch("https://hs2api.razamit.pl/usersList", { credentials: 'include' }).then(res => res.json())

      ]);

      setOptions({
        allFv: fv || [],
        statuses: statuses.statuses || [],
        users: users || [],
        userCanAdd: []
      });
    } catch (err) {
      console.error("Błąd pobierania danych:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllData();
  }, []);


  const openAddFVModal = (row) => 
    {
      setEditingFV(null);
      setFormFV({
        costTitle: "",
        cost: "",
        costDate: "",
        costPaidBy: ""
      });
       setDetails(row);
    setOpenAddFV(true);
  }


  const openAddCostModal = () => 
    {
      setEditing(null);
      setForm({
        costTitle: "",
        cost: "",
        costDate: "",
        costPaidBy: ""
      });
    setOpenAddCost(true);
  }
  const markSettled = (id) => setCosts(costs.map(c => c.id === id ? { ...c, status: 'settled' } : c));

  const total = options.allFv.reduce((sum, c) => sum + Number(c.amount), 0);
  const rozliczono = options.allFv.reduce((sum, c) =>  sum + Number(c.total_fv_value), 0);
  const dorozliczenia = options.allFv.reduce((sum, c) => {if(c.status !=="3") return sum + Number(c.amount); return sum}, 0);
  const iloscfv = options.allFv.length;
const statuses = [
  { id: "1", name: 'Nowe', canUse: 1, class:"bg-green-500 text-white" },
  { id: "2", name: 'Do akceptacji', canUse: 1, class:"bg-yellow-500 text-white" },
  { id: "3", name: 'Rozliczono', canUse: 1, class:"bg-primary-500 text-white" },
  { id: "4", name: 'Rozliczanie', canUse: 1, class:"bg-blue-500 text-white" },
];
  const columns = useMemo(() => [
    {
  field: 'status',
  headerName: 'Status',
  renderCell: (params) => {
    const row = params.row;
    const status = statuses.find(s => s.id === row.status);

    if (!status) return null;

    return (
      <span
        className={`px-2 py-1 rounded text-xs font-semibold ${
          status.class
        }`}
        title={status.status_description}
      >
        {status.name}
      </span>
    );
  },
},
    {
      field: 'title',
      headerName: 'Tytuł faktury',
      renderCell: (params) => {
        const row = params.row;
     
        return (
          <div className="flex items-center gap-2">
            <span className="px-2 py-1 rounded text-xs font-normal text-gray-900">
            {row.title}
            </span>
          </div>
        );
      }
    },
     {
      field: 'number',
      headerName: 'Numer faktury',
      renderCell: (params) => {
        const row = params.row;
     
        return (
          <div className="flex items-center gap-2">
            <span className="px-2 py-1 rounded text-xs font-normal text-gray-900">
            {row.fvnumber}
            </span>
          </div>
        );
      }
    },
    
    {
      field: 'date',
      headerName: 'Data faktury',
      renderCell: (params) => {
        const row = params.row;
        let date = row.date ? format(parseISO(String(row.date)), 'yyyy-MM-dd', { locale: pl }) : "-";
        return <span className="font-medium text-gray-900">{date}</span>;
      }
    },
    {
      field: 'Kwota',
      headerName: 'Zapłacono',
      renderCell: (params) => {
        const row = params.row;
        return (
          <div className="flex items-center gap-2">
            <span className="px-2 py-1 rounded text-xs font-normal text-gray-900">
              {row.amount}
            </span>
          </div>
        );
      }
    },
     {
      field: 'Kwota',
      headerName: 'Spłacono',
      renderCell: (params) => {
        const row = params.row;

        const paid = Number(row.total_fv_value);
    const amount = Number(row.amount);

    let colorClass = 'bg-gray-200 text-gray-900';
    let showAlert = false;
        let showWarning = false;
    let showSuccess = false;


    if (paid === amount) {
      colorClass = ' text-green-900';
      showSuccess = true;
    } else if (paid < amount) {
      colorClass = ' text-red-900';
      showAlert = true;
    } else if (paid > amount) {
      colorClass = ' text-yellow-900';
      showWarning = true;
    }
        return (
           <div className="flex items-center gap-1">
             {showAlert && (
            <span className="mr-1 text-red-600 font-bold">!</span>
          )}
           {showWarning && (
            <span className="mr-1 text-yellow-600 font-bold">⚠</span>
          )}
           {showSuccess && (
            <span className="mr-1 text-green-600 font-bold">✓</span>
          )}
        <span
          className={`px-2 py-1 rounded text-normal font-bold ${colorClass}`}
        >
          {row.total_fv_value}
         
        </span>
      </div>
        );
      }
    },
    {
      field: 'paydBy',
      headerName: 'Zapłacił',
      renderCell: (params) => <span className="font-medium text-gray-900">{params.row.us_name}</span>
    },
   
    {
        field: 'actions', headerName: 'Akcje',width:50, sortable: false, renderCell: (params) => (
          <div className="flex gap-2">
          <CostActions logedUser={logedUser}  row={params.row} onEdit={onEdit} RunCost={onRunCost} addPayCostFV={openAddFVModal}  onDelete={onDelete} details={handleOpenDetailsCost} />
        </div>
        
        )
      }
  ], []);

  return (
    <div>
      <PageHeaderPortal title="Utrzymanie systemu" subtitle="Wewnętrzne wydatki poniesione na rozwój aplikacji" />

      <Tabs
        tabs={[
          {
            id: "tab1",
            label: "Poniesione",
            icon: <BsCardChecklist size={16} />,
            content: (
              <div className="space-y-4">
                <div className="sticky top-[120px] bg-white border border-gray-200 rounded-md p-4 z-10 mb-2">
                  <p className="text-sm text-gray-500 text-center md:text-left">
                    <span className="font-bold text-yellow-600 mr-1">WAŻNE!</span>
                    Dodaj koszty realnie poniesione na działanie i utrzymanie systemu aby poprawnie je rozliczyć
                  </p>

                  <div className="flex flex-row items-center gap-3 mt-4 md:mt-0 md:justify-end">
                    <button
                      onClick={openAddCostModal}
                      className="flex items-center gap-2 !text-xs md:text-sm px-4 py-2 text-gray-700 border border-gray-200 rounded hover:border-primary-500 transition"
                    >
                      <BsPlus className="w-4 h-4" /> Dodaj koszt
                    </button>
                  </div>
                </div>

                <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-2 sm:gap-5 mb-2 sm:mb-5">
                  <StatCard label="Łączne koszta" value={`${total} PLN`} />
                  <StatCard label="Rozliczono" value={`${rozliczono} PLN`} />
                  <StatCard label="Do rozliczenia" value={`${dorozliczenia} PLN`} />
                  <StatCard label="Ilość faktur" value={iloscfv} />
                </div>

                <div className="rounded-sm overflow-hidden">
                  <Table columns={columns} data={options.allFv} loading={loading} />
                </div>
              </div>
            )
          },
          { id: "tab2", label: "Planowane", icon: <BsClock size={16} />, content: <div>Planowane wydatki</div> }
        ]}
      />

      <Snackbar open={toast.open} message={toast.message} onClose={() => setToast({ ...toast, open: false })} severity={toast.severity} className="shadow-lg" />
     {openDetailsCost && details && (
      <CostDetailsDialog open={openDetailsCost} onClose={() => setOpenDetailsCost(false)} details={details} users={options.users} setLoading={setLoading} />

     )}
     
      <AddEditCostsDialog options={options} open={openAddCost} onClose={() => setOpenAddCost(false)} editing={editing} form={form} setForm={setForm} submitForm={submitForm}/>
{openAddFV && details && (
  <AddEditFVAditionalCostDialog
    options={options}
    open={openAddFV}
    onClose={() => setOpenAddFV(false)}
    editing={editingFV}
    details={details}
    form={formFV}
    setForm={setFormFV}
    submitForm={submitFormFV}
  />
)}
 
    </div>
  );
}
